import CustomerForm from '@/components/orders/CustomerForm'
import { useCreateCustomer } from '@/queries/customers'
import { Customer } from '@/types'
import { Modal } from '@mantine/core'

export default function CustomerCreationModal({
  opened,
  onClose,
  onCreated,
  organizationSlug,
}: {
  opened: boolean
  onClose: () => void
  onCreated: (customer: Customer) => void
  organizationSlug: string
}) {
  const { mutate: createCustomer, isPending } = useCreateCustomer({ organizationSlug })

  return (
    <Modal opened={opened} onClose={onClose} title="Nouveau client" centered>
      <CustomerForm
        onSubmit={(values) => createCustomer(values, { onSuccess: onCreated })}
        submitLabel={isPending ? 'Création...' : 'Créer le client'}
      />
    </Modal>
  )
}
